import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch actions for a specific community
 */
export const GET_COMMUNITY_ACTIONS = gql`
  query GetCommunityActions($communityId: ID!) {
    community(id: $communityId) {
      id
      actions {
        name
        type
        description
        deliveryType
        workflowType
        labels {
          labelId
          severity
        }
        policies
        operatorName
        deliverySettings {
          url
          postPayload
        }
      }
    }
  }
`;
